import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import SVG from '../SVG/SVG'
import { isClientSide } from '../Common/utils'
import obj2Arr from '../../../utils/obj2Arr'
import { setCookie, getCookie } from '../../../utils/cookies'

const useStyles = createUseStyles(theme => ({
  spacer: {
    height: '110px',
    '@media (max-width: 1024px)': {
      height: '86px',
    },
  },
  spacerAlertBar: {
    height: '151px',
    '@media (max-width: 1024px)': {
      height: '127px',
    },
  },
  header: {
    fontFamily: theme.fontFamily,
    // overflowX: 'hidden',
    position: 'fixed',
    width: '100%',
    left: 0,
    top: 0,
    zIndex: 99999,
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd',
  },
  headerMini: {
    display: 'block',
    '@media (max-width: 1024px)': {
      display: 'none',
    },

    backgroundColor: theme.colors.eggshell,

    '& a': {
      backgroundColor: ' transparent',
      color: theme.colors.warmGrey,
      display: 'inline-block',
      fontSize: 13,
      fontWeight: 'bold',
      letterSpacing: 1,
      lineHeight: '15px',
      padding: '8px 25px',
      textDecoration: 'none',
      transition: `background-color 250ms ${theme.animations.bezier}, color 250ms ${theme.animations.bezier}`,

      '&.tel': {
        color: theme.colors.deepsea,
      },

      '&:hover': {
        backgroundColor: theme.colors.silver,
        color: theme.colors.coal,
      },
    },
  },
  headerMiniInner: {
    ...theme.wrappers.standard,
    textAlign: 'right',
    '& > a:last-child': {
      marginRight: -25,
    },
  },
  headerMainInner: {
    ...theme.wrappers.standard,
    // padding: "0 0 0 25px",
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    minHeight: '110px',
    '@media (max-width: 1024px)': {
      minHeight: '0',
    },
  },
  headerLogo: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      height: '79px',
      maxWidth: 129,
      width: '100%',
    },
  },
  headerNav: {
    marginLeft: '54px',
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  mobileTrigger: {
    display: 'none',
    cursor: 'pointer',
    padding: '2em 1em',
    // padding: 25,
    // flexGrow: 1,
    justifyContent: 'flex-end',
    '@media (max-width: 1024px)': {
      display: 'flex',
    },
  },
  mobileLogin: {
    display: 'none',
    cursor: 'pointer',
    padding: '2em 0',
    marginLeft: 'auto',
    '@media (max-width: 1024px)': {
      display: 'flex',
    },
  },
  headerNavItems: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,

    '& li:first-child': {
      marginLeft: 0,
    },
  },
  headerNavItem: {
    float: 'left',
    margin: 0,
    padding: 0,
    marginLeft: 40,
    height: 110,
    display: 'flex',
    alignItems: 'center',
    '& .hoverMenu': {
      display: 'none',
    },
    '@media (min-width: 1024px)': {
      '&': {
        //'&:hover': {
        '&.is-active .hoverMenu, &:hover .hoverMenu': {
          width: '100%',
          zIndex: 3,
          backgroundColor: theme.colors.mainHover,
          boxSizing: 'border-box',
          display: 'flex',
          position: 'absolute',
          top: 110,
          left: 0,
          paddingTop: 20,
          paddingBottom: 20,
          borderTop: '1px solid #ddd',
          '& .hoverMenuLinks': {
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: 1490,
            paddingLeft: 230,
            margin: '0 auto',
            display: 'flex',
          },
          '& ul': {
            listStyle: 'none',
            boxSizing: 'border-box',
            padding: 0,
            marginRight: 0,
            width: 'auto',
            '& li': {
              marginBottom: 0,
              marginRight: 20,
              display: 'inline-block',
              '&:last-child': {
                marginBottom: 0,
                marginRight: 0,
              },
              '& a': {
                fontSize: 16,
                lineHeight: 1.5,
                letterSpacing: '0.02em',
                textDecoration: 'none',
                color: '#fff',
                fontWeight: 500,
                display: 'inline-block',
                marginRight: 20,
                '&:hover, &.activeMenuLink': {
                  textDecoration: 'underline',
                },
                '&:last-child': {
                  marginRight: 0,
                },
              },
              '& span': {},
            },
          },
        },
      },
    },
  },
  headerNavItemRight: {
    float: 'left',
    margin: 0,
    padding: 0,
    marginLeft: 30,
  },

  headerNavOtherLinksMobile: {
    marginBottom: 15,
    display: 'block',
    color: '#000',
    textDecoration: 'none',
  },
  headerNavOtherLinks: {
    marginRight: 30,
    display: 'inline-block',
    color: '#000',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  headerNavLink: {
    color: '#000',

    display: 'block',
    textAlign: 'center',
    padding: '6px 0 6px',
    textDecoration: 'none',
    borderBottom: '6px solid #fff',
    fontSize: 16,
    lineHeight: '19px',
    fontWeight: 500,
    transition: `border-bottom 250ms ${theme.animations.bezier}`,
    '&.is-active, &:hover': {
      borderBottom: `5px solid ${theme.colors.red}`,
    },
  },
  headerNavLinkBooking: {
    borderRadius: theme.buttonBorderRadius,
    backgroundColor: theme.colors.main,
    color: theme.colors.white,
    fontSize: '1rem',
    letterSpacing: '0.1px',
    lineHeight: 'normal',
    textAlign: 'center',
    display: 'inline-block',
    paddingRight: 20,
    paddingLeft: 20,
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: 1,
    textDecoration: 'none',
    fontWeight: 500,
    transition: `background-color 250ms ${theme.animations.bezier}`,
    '&:hover': {
      backgroundColor: theme.colors.mainHover,
      borderBottom: 'transparent',
    },
  },
  mobileNav: {
    display: 'none',
    position: 'fixed',
    top: 90,
    left: 0,
    width: '100%',
    zIndex: 500,
    padding: 10,
    height: 'calc(100vh - 90px)',
    background: 'white',
    boxSizing: 'border-box',
    borderTop: '1px solid #CCCCCC',
    '@media (min-width: 1024px)': {
      display: 'none !important',
    },
  },
  mobileNavActive: {
    display: 'flex',
  },
  mobileNavInner: {
    boxSizing: 'border-box',
    // maxWidth: 250,
    margin: '0 auto',
    padding: '0 30px 30px 30px',
    // position: "sticky",
    // top: 0,
    opacity: 1,
    height: '100%',
    // overflow: "hidden",
    // pointerEvents: "none",
    width: '100%',

    '&.active': {
      // "& div": {
      //   pointerEvents: "all",
      //   overflow: "visible",
      // }
    },
  },
  mobileHeaderMini: {
    boxSizing: 'border-box',
    marginBottom: 25,
    marginTop: '0',
    marginLeft: 'auto',
    marginRight: 'auto',
    // textAlign: "center",
    // width: "100%",
    '& .tel': {
      display: 'none',
    },
    '@media (max-width: 1024px)': {
      '& a:last-child': {
        backgroundColor: theme.colors.deepsea,
      },
    },
  },
  mobileHeaderMiniButtons: {
    marginRight: 15,
    backgroundColor: theme.colors.blue,
    borderRadius: theme.borderRadius,
    color: theme.colors.white,
    display: 'inline-block',
    fontSize: 14,
    fontWeight: 'bold',
    padding: '5px 10px',
    textDecoration: 'none',
    transition: `background-color 250ms ${theme.animations.bezier}`,

    '&:hover': {
      backgroundColor: theme.colors.deepsea,
    },
  },
  mobileNavItems: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '& .is-closed': {
      display: 'none',
    },
  },
  mobileHeaderNavLink: {
    color: '#000000',
    cursor: 'pointer',
    display: 'inline-block',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '28px',
    marginTop: 30,
    position: 'relative',
    textDecoration: 'none',
    transition: `border-left 250ms ${theme.animations.bezier}`,
    width: '100%',
  },
  mobileNavBooking: {
    marginTop: 20,
  },
  mobileNavContact: {
    marginTop: 30,
  },
  headerNavWrapper: {
    display: 'block',
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  sitelogo: {
    '& img': {
      width: 152,
      height: 55,
      '@media (max-width: 1024px)': {
        width: 'auto',
        height: 33,
      },
    },
  },
  icon: {
    marginLeft: 'auto',
    '& svg': {
      transform: 'rotate(90deg)',
      transition: `transform 250ms ${theme.animations.bezier}`,
    },
  },

  iconActive: {
    marginLeft: 'auto',
    '& svg': {
      transform: 'rotate(-90deg)',
      transition: `transform 250ms ${theme.animations.bezier}`,
    },
  },
  toggleBtn: {
    backgroundColor: '#F0F0F0',
    boxShadow: '0px 2px 2px 1px rgba(0, 0, 0, 0.12)',
    borderRadius: '50%',
    width: '24px',
    height: '22px',
    paddingTop: '2px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 20,
    '& svg': {
      transform: 'rotate(90deg)',
      transition: `transform ${theme.animations.animate}`,
    },
    '&.is-active': {
      '& svg': {
        transform: 'rotate(-90deg)',
        transition: `transform 250ms ${theme.animations.bezier}`,
      },
    },
  },

  alertBarText: {
    fontSize: '16px',
    fontWeight: '300',
    '& a': {
      color: '#000',
      textDecoration: 'underline',
    },
  },
}))

const Header = props => {
  const { rightLinks, menuLinks, WebSettings, alertBars } = props
  const classes = useStyles()
  const [alertBarActive, setAlertBarActive] = useState(false)
  const [active, setActiveState] = useState(false)
  const [subMenu, setSubMenu] = useState('')
  const [subMenuActive, setSubMenuActive] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const enableSubNav = arr => {
    try {
      if (arr.length > 0) {
        const emre = arr.map(item => item.filter(link => link.hidden == '0'))
        return emre.flat(1).length > 0
      }
      return false
    } catch (error) {
      return false
    }
  }

  function toggleMenu() {
    const newState = !active
    if (isClientSide) {
      document.querySelector('body').style.overflow = newState ? 'hidden' : 'auto'
      document.querySelector('body').style.height = newState ? '100vh' : 'auto'
    }
    setActiveState(newState)
  }

  const mobileClasses = active
    ? `${classes.mobileNav} ${classes.mobileNavActive}`
    : classes.mobileNav

  useEffect(() => {
    const currentPath = window.location.pathname
    const emreLinks = [...menuLinks, ...rightLinks]

    emreLinks.map(link => {
      if (link.href === currentPath && link.items.length > 0) setSubMenuActive(true)
      try {
        if (link.items.length > 0) {
          link.items.map(linkx => {
            if (linkx.href === currentPath) setSubMenuActive(true)
          })
        }
      } catch (error) {}
      setSubMenu(currentPath)
    })
    if (window.innerWidth < 1024) {
      setIsMobile(true)
    }
  }, [menuLinks, rightLinks])

  const AlertContent = ({ icon, text }) => {
    const [viewBar, setViewBar] = useState(false)

    const hideBar = () => {
      setCookie('hidebar', 'on', 1)
      setViewBar(false)
      setAlertBarActive(false)
    }

    useEffect(() => {
      if (getCookie('hidebar') !== 'on') {
        setViewBar(true)
        setAlertBarActive(true)
      }
    }, [])

    if (!viewBar) {
      return null
    }

    return (
      <div style={{ backgroundColor: '#ddd', padding: '10px' }}>
        <div
          style={{
            width: '100%',
            maxWidth: '1220px',
            margin: '0 auto',
            justifyContent: 'space-between',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div style={{ paddingRight: '10px', display: 'flex', alignItems: 'center' }}>
            <img
              style={{ mixBlendMode: 'multiply', marginRight: '8px' }}
              src={`/themes/dollar/assets/images/${icon}.png`}
              alt=""
              width="20px"
              height="20px"
            />
            <span dangerouslySetInnerHTML={{ __html: text }} className={classes.alertBarText} />
          </div>
          <button
            onClick={hideBar}
            type="button"
            style={{ border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.3525 1.38372C17.7667 0.797933 16.8169 0.797933 16.2311 1.38372L9.86719 7.74768L3.50323 1.38372C2.91744 0.797932 1.96769 0.797932 1.38191 1.38372C0.796119 1.96951 0.796119 2.91925 1.38191 3.50504L7.74587 9.869L1.3819 16.233C0.796119 16.8187 0.796118 17.7685 1.3819 18.3543C1.96769 18.9401 2.91744 18.9401 3.50323 18.3543L9.86719 11.9903L16.2311 18.3543C16.8169 18.9401 17.7667 18.9401 18.3525 18.3543C18.9383 17.7685 18.9383 16.8187 18.3525 16.233L11.9885 9.869L18.3525 3.50504C18.9383 2.91925 18.9383 1.96951 18.3525 1.38372Z"
                fill="#666"
              />
            </svg>
          </button>
        </div>
      </div>
    )
  }

  const AlertBar = () => {
    if (Number(alertBars.BAR_ALERT) === 0) {
      return <AlertContent icon="alert_icon" text={WebSettings.BAR_ALERT} />
    }

    if (Number(alertBars.BAR_HOT_DEAL) === 0) {
      return <AlertContent icon="hot_deal_icon" text={WebSettings.BAR_HOT_DEAL} />
    }

    if (Number(alertBars.BAR_INFORMATION) === 0) {
      return <AlertContent icon="Info_Icon" text={WebSettings.BAR_INFORMATION} />
    }

    return null
  }

  return (
    <>
      <style>{`
      .react-toast-notifications__container {
        z-index: 999999 !important;
      }`}</style>
      <div
        className={alertBarActive ? classes.spacerAlertBar : classes.spacer}
        style={subMenuActive && !isMobile ? { marginBottom: 50 } : {}}
      ></div>
      <header
        className={classes.header}
        style={subMenuActive && !isMobile ? { marginBottom: 50 } : {}}
      >
        <AlertBar />

        <div className={classes.headerMain}>
          <div className={classes.headerMainInner}>
            <div className={classes.headerLogo}>
              <a href="/" className={classes.sitelogo}>
                <img src="/themes/dollar/assets/images/logo.png" alt="Dollar" />
              </a>
              <nav className={classes.headerNav}>
                <ul className={classes.headerNavItems}>
                  {menuLinks
                    .filter(menuLink => menuLink.hidden == '0')
                    .map((link, index) => {
                      const isSubMenu =
                        link.href === subMenu || link.items.find(item => item.href === subMenu)
                      return (
                        <li
                          className={`${classes.headerNavItem} ${isSubMenu ? 'is-active' : null}`}
                          key={`header-menu-link-${index}`}
                        >
                          <a
                            href={link.href}
                            className={`${classes.headerNavLink} ${isSubMenu ? 'is-active' : null}`}
                            target={link.external == '1' ? '_blank' : ''}
                            rel="noreferrer"
                          >
                            {link.text}
                          </a>
                          {link.itemsOpt &&
                            obj2Arr(link.itemsOpt).length > 0 &&
                            enableSubNav(obj2Arr(link.itemsOpt)) && (
                              <div
                                className="hoverMenu"
                                style={alertBarActive ? { top: 151 } : undefined}
                              >
                                <div
                                  className="hoverMenuLinks"
                                  style={{
                                    paddingRight: '35px',
                                    justifyContent: 'end',
                                  }}
                                >
                                  {obj2Arr(link.itemsOpt).map((itemLinks, itemIndexOpt) => (
                                    <ul key={`header-menu-item-link-${itemIndexOpt}`}>
                                      {itemLinks
                                        .filter(link => link.hidden == '0')
                                        .map((itemLink, itemIndex) => (
                                          <li key={`header-menu-item-link-${itemIndex}`}>
                                            {itemLink.href && (
                                              <a
                                                className={
                                                  subMenu === itemLink.href ? `activeMenuLink` : ''
                                                }
                                                href={itemLink.href}
                                                target={itemLink.external == '1' ? '_blank' : ''}
                                                rel="noreferrer"
                                              >
                                                {itemLink.text}
                                              </a>
                                            )}
                                            {/* {!itemLink.href && <span>{itemLink.text}</span>} */}
                                          </li>
                                        ))}
                                    </ul>
                                  ))}
                                </div>
                              </div>
                            )}
                        </li>
                      )
                    })}
                </ul>
              </nav>
            </div>

            <div className={classes.headerNavWrapper}>
              <ul className={classes.headerNavItems}>
                {rightLinks
                  .filter(rightLink => rightLink.hidden == '0')
                  .map((link, index) => {
                    const isSubMenu =
                      link.href === subMenu || link.items.find(item => item.href === subMenu)
                    return (
                      <li
                        className={`${classes.headerNavItem} ${isSubMenu ? 'is-active' : null}`}
                        key={`header-menu-link-${index}`}
                      >
                        <a
                          href={link.href}
                          className={`${classes.headerNavLink} ${isSubMenu ? 'is-active' : null}`}
                          target={link.external == '1' ? '_blank' : ''}
                          rel="noreferrer"
                        >
                          {link.text}
                        </a>
                        {link.itemsOpt &&
                          obj2Arr(link.itemsOpt).length > 0 &&
                          enableSubNav(obj2Arr(link.itemsOpt)) && (
                            <div
                              className="hoverMenu"
                              style={alertBarActive ? { top: 151 } : undefined}
                            >
                              <div className="hoverMenuLinks">
                                {obj2Arr(link.itemsOpt).map((itemLinks, itemIndexOpt) => (
                                  <ul key={`header-menu-item-link-${itemIndexOpt}`}>
                                    {itemLinks
                                      .filter(link => link.hidden == '0')
                                      .map((itemLink, itemIndex) => (
                                        <li key={`header-menu-item-link-${itemIndex}`}>
                                          {itemLink.href && (
                                            <a
                                              className={
                                                subMenu === itemLink.href ? `activeMenuLink` : ''
                                              }
                                              href={itemLink.href}
                                              target={itemLink.external == '1' ? '_blank' : ''}
                                              rel="noreferrer"
                                            >
                                              {itemLink.text}
                                            </a>
                                          )}
                                          {/* {!itemLink.href && <span>{itemLink.text}</span>} */}
                                        </li>
                                      ))}
                                  </ul>
                                ))}
                              </div>
                            </div>
                          )}
                      </li>
                    )
                  })}

                {WebSettings.headerButtonText && (
                  <li className={classes.headerNavItemRight}>
                    <a
                      href={WebSettings.headerButtonURL}
                      className={classes.headerNavLinkBooking}
                      style={{ cursor: 'pointer' }}
                    >
                      {WebSettings.headerButtonText}
                    </a>
                  </li>
                )}
              </ul>
            </div>
            <div className={mobileClasses}>
              <div className={classes.mobileNavInner} style={{ gridArea: 'left' }}>
                <nav>
                  <ul className={classes.mobileNavItems}>
                    {menuLinks.map((link, index) => (
                      <li
                        key={`header-menu-mobile-link-${index}`}
                        className={classes.mobileNavItems}
                      >
                        <a
                          href="#"
                          onClick={e => {
                            e.preventDefault()
                            if (link.itemsOpt && obj2Arr(link.itemsOpt).length > 0) {
                              if (
                                document
                                  .querySelector(`#submenu${index}`)
                                  .classList.contains('is-closed')
                              ) {
                                document
                                  .querySelector(`#toggle-btn-${index}`)
                                  .classList.add('is-active')
                                document
                                  .querySelector(`#submenu${index}`)
                                  .classList.remove('is-closed')
                              } else {
                                document
                                  .querySelector(`#toggle-btn-${index}`)
                                  .classList.remove('is-active')
                                document
                                  .querySelector(`#submenu${index}`)
                                  .classList.add('is-closed')
                              }
                            } else {
                              top.location = link.href
                            }
                          }}
                          className={`${classes.mobileHeaderNavLink} ${
                            link.class ? link.class : ''
                          }`}
                        >
                          {link.text}
                          {link.itemsOpt &&
                            obj2Arr(link.itemsOpt).length > 0 &&
                            enableSubNav(obj2Arr(link.itemsOpt)) && (
                              <span className={`${classes.toggleBtn}`} id={`toggle-btn-${index}`}>
                                <SVG name="Chevron" width={10} height={10} />
                              </span>
                            )}
                        </a>
                        {link.itemsOpt &&
                          obj2Arr(link.itemsOpt).length > 0 &&
                          enableSubNav(obj2Arr(link.itemsOpt)) && (
                            <div className={`is-closed`} id={`submenu${index}`}>
                              <>
                                {obj2Arr(link.itemsOpt).map((itemLinks, itemIndexOpt) => (
                                  <ul
                                    key={`subheader-menu-item-link-${itemIndexOpt}`}
                                    style={{ padding: 0, margin: 0, listStyle: 'none' }}
                                  >
                                    {itemLinks
                                      .filter(link => link.hidden == '0')
                                      .map((itemLink, itemIndex) => (
                                        <li
                                          key={`header-menu-item-link-${itemIndex}`}
                                          className={
                                            itemLink.href ? `linksubmenu${itemIndexOpt}` : ''
                                          }
                                        >
                                          {itemLink.href && (
                                            <a
                                              href={itemLink.href}
                                              style={{
                                                fontSize: '16px',
                                                lineHeight: '24px',
                                                letterSpacing: '0.02em',
                                                fontWeight: 300,
                                                textDecoration: 'none',
                                                padding: '12px 0 6px',
                                                display: 'block',
                                                color: '#000',
                                              }}
                                              target={itemLink.external == '1' ? '_blank' : ''}
                                              rel="noreferrer"
                                            >
                                              {itemLink.text}
                                            </a>
                                          )}
                                        </li>
                                      ))}
                                  </ul>
                                ))}{' '}
                              </>
                            </div>
                          )}
                      </li>
                    ))}
                  </ul>
                </nav>
                <div style={{ marginTop: 30 }}>
                  {WebSettings.headerLink1Text && (
                    <a
                      href={WebSettings.headerLink1URL}
                      className={classes.headerNavOtherLinksMobile}
                    >
                      {WebSettings.headerLink1Text}
                    </a>
                  )}
                  {WebSettings.headerLink2Text && (
                    <a
                      href={WebSettings.headerLink2URL}
                      className={classes.headerNavOtherLinksMobile}
                    >
                      {WebSettings.headerLink2Text}
                    </a>
                  )}
                </div>
                {/* <div
                style={{
                  minHeight: 170,
                  backgroundImage: 'url(/themes/dollar/assets/images/menupic.png)',
                  borderRadius: '',
                  gridArea: 'bottom',
                  borderRadius: 16,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center center',
                }}
              /> */}
              </div>
            </div>
            <div className={classes.mobileLogin}>
              {WebSettings.headerButtonText && (
                <a
                  href={WebSettings.headerButtonURL}
                  className={classes.headerNavLinkBooking}
                  style={{ cursor: 'pointer' }}
                >
                  {WebSettings.headerButtonText}
                </a>
              )}
            </div>
            <div className={classes.mobileTrigger} onClick={toggleMenu}>
              <div style={{ width: 30, textAlign: 'center' }}>
                {active ? (
                  <SVG name={'Cross'} width={18} height={18} colorOne={'#C8102E'} />
                ) : (
                  <SVG name={'Menu'} width={30} height={18} colorOne={'#C8102E'} />
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

Header.propTypes = {
  menuLinkManageText: PropTypes.string,
  menuLinkManageHref: PropTypes.string,

  menuLinkPhoneText: PropTypes.string,
  menuLinkPhoneAltText: PropTypes.string,
  menuLinkPhoneHref: PropTypes.string,

  menuLinkContactText: PropTypes.string,
  menuLinkContactHref: PropTypes.string,

  menuLinks: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
      class: PropTypes.node,
    }),
  ),
}

export default Header
